<template>
  <div class="container" v-if="h5ContentInfo">
    <van-image class="banner" fit="cover" :src="h5ContentInfo.InsidePicUrl" />
    <div class="contentInfo">
      <div class="title" v-text="h5ContentInfo.Title"></div>
      <div class="subBottom">
        <div class="time">
          {{ h5ContentInfo.CreateTime | formatTime('MM-DD HH:mm') }}
        </div>
        <div class="authorInfo">
          <van-image class="authorPic" fit="cover" round :src="defaultAuthorHeader" />
          <div class="author" v-text="h5ContentInfo.Author"></div>
        </div>
      </div>
    </div>
    <div v-for="(item, index) in h5ContentInfo.PicContentList" :key="index" class="htmlMain">
      <div class="htmlContent" v-html="item.ContentHtml"></div>
      <carefully-chosen-goods-card v-if="item.H5ContentDetailProduct" :goodsCardInfo="item.H5ContentDetailProduct" @goToBuy="goToBuy"></carefully-chosen-goods-card>
    </div>
    <div class="carefullyChosenDetailEmptyBox"></div>
    <div class="bottomMain">
      <div v-if="h5ContentInfo.ReadCount" class="readUserList">
        <van-image v-for="(item, index) in h5ContentInfo.ReadHeadPortraitUrl" :key="index" round class="userPic" fit="cover" :src="item" />
        <div v-if="Number(h5ContentInfo.ReadCount) > 3" class="more">
          <van-icon name="ellipsis" />
        </div>
        <span>{{ h5ContentInfo.ReadCount | formatMaxNum }}人阅读</span>
      </div>
      <div class="rightPart">
        <div class="item" @click="shareHandler">
          <div class="iconfontBox">
            <span class="iconfont icon-fenxiang2"></span>
          </div>
          <span class="shareText">分享</span>
        </div>
        <div class="item" :class="{ memberIsLike: h5ContentInfo.MemberIsLike }" @click="memberIsLikeHandler">
          <div class="iconfontBox animationIconfontBox">
            <span class="iconfont icon-dianzan11"></span>
            <span v-if="isShowIconAnimation" :class="{ heart: likeActive }" class="iconfont icon-dianzan11 icon-animation"></span>
          </div>
          <span>{{ h5ContentInfo.LikeCount | formatMaxNum }}</span>
        </div>
      </div>
    </div>
    <coupon-dialog v-if="couponDialogShow" :data-info="couponDataInfo" :err-feedback="dialogErrFeedback" @close="couponDialogShow = false"> </coupon-dialog>
  </div>
</template>

<script>
import { IMG_BASE_URL } from '@/config/index'
import { Indicator } from 'mint-ui'
import { Icon, Image as VanImage } from 'vant'
import CarefullyChosenGoodsCard from './children/CarefullyChosenGoodsCard.vue'
import CouponDialog from '@/components/smartComponent/CouponDialog'
import { H5ContentGet, LikeAdd, LikeSub, CententProductGetCoupon, ContentToShare } from '@/api/souhuo'

export default {
  name: 'SouhuoH5Carefullychosenpage',

  data() {
    return {
      id: '',
      h5ContentInfo: null,
      // 优惠券弹窗
      couponDialogShow: false,
      dialogErrFeedback: false,
      couponDataInfo: {},
      defaultAuthorHeader: IMG_BASE_URL + `/upaiyun/Sys/20220524/5382640542960103103.jpg`,
      likeActive: false,
      isShowIconAnimation: true,
      timer1: null,
      isLikeApiBack: true
    }
  },

  components: {
    CarefullyChosenGoodsCard,
    VanImage,
    'van-icon': Icon,
    CouponDialog
  },

  created() {
    this.id = this.$route.query.id ? this.$route.query.id : ''
    this.getH5Content()
  },

  methods: {
    getH5Content() {
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      H5ContentGet({ id: this.id })
        .then((res) => {
          Indicator.close()
          res.H5ContentDetailInfo.PicContentList.forEach((element) => {
            element.ContentHtml = element.ContentHtml.replace(/<img/g, "<img style='max-width:100%;height:auto;display:block;margin:10px 0;'")
          })
          this.h5ContentInfo = res.H5ContentDetailInfo
        })
        .catch((res) => {
          Indicator.close()
          this.$toast.clear()
          if (res.ErrMsg) {
            this.$toast(res.ErrMsg)
            this.$router.go(-1)
          }
        })
    },
    memberIsLikeHandler() {
      if (this.timer1 !== null || !this.isLikeApiBack) {
        return
      }
      this.isLikeApiBack = false
      this.likeActive = true
      this.timer1 = setTimeout(() => {
        this.isShowIconAnimation = false
        this.$nextTick(() => {
          this.likeActive = false
          this.isShowIconAnimation = true
          this.$nextTick(() => {
            this.timer1 = null
          })
        })
      }, 1000)
      let historyMemberIsLike = this.h5ContentInfo.MemberIsLike
      let methedName = historyMemberIsLike ? LikeSub : LikeAdd
      methedName({ id: this.id })
        .then((res) => {
          if (historyMemberIsLike) {
            --this.h5ContentInfo.LikeCount
          } else {
            ++this.h5ContentInfo.LikeCount
          }
          this.h5ContentInfo.MemberIsLike = !this.h5ContentInfo.MemberIsLike
          this.isLikeApiBack = true
        })
        .catch((res) => {
          this.$toast.clear()
          if (res.ErrMsg) {
            this.$toast(res.ErrMsg)
          }
          this.isLikeApiBack = true
        })
    },
    goToBuy(goodsCardInfo) {
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      let { NumIID, PictUrl, Title, click_url, coupon_share_url } = goodsCardInfo
      CententProductGetCoupon({
        id: this.id,
        numIID: NumIID,
        pictUrl: PictUrl,
        title: Title,
        click_url,
        coupon_share_url,
        tljOrderType: 0
      })
        .then((res) => {
          Indicator.close()
          this.couponDataInfo = {
            goodsImg: PictUrl,
            pwdStr: res.Data
          }
          this.couponDialogShow = true
        })
        .catch((res) => {
          Indicator.close()
          this.$toast.clear()
          if (res.ErrMsg) {
            this.$toast(res.ErrMsg)
          }
        })
    },
    shareHandler() {
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      ContentToShare({ id: this.id })
        .then((res) => {
          Indicator.close()
          this.$router.push({
            name: 'ShareByImg',
            query: {
              shareSrc: res.Data
            }
          })
        })
        .catch((res) => {
          Indicator.close()
          this.$toast.clear()
          if (res.ErrMsg) {
            this.$toast(res.ErrMsg)
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
$base_width: 375;
@function vw($px) {
  @return ($px / $base_width) * 100vw;
}

.container {
  background: #ffffff;
}
.carefullyChosenDetailEmptyBox {
  width: 100%;
  height: vw(100);
}

.banner {
  width: 100%;
  height: vw(190);
}

.contentInfo {
  padding: 0 vw(18);
  margin-bottom: vw(24);
  .title {
    font-size: vw(20);
    font-weight: 700;
    margin: vw(16) 0;
  }
  .subBottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: vw(12);
    color: #999999;
    .authorInfo {
      display: flex;
      align-items: center;
      .authorPic {
        width: vw(20);
        height: vw(20);
        margin-right: vw(5);
      }
    }
  }
}

.htmlMain {
  .htmlContent {
    padding: 0 vw(18);
    line-height: 2em;
    // font-size: vw(18);
    color: #353535;
  }
}

.bottomMain {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: vw(54);
  background: #ffffff;
  box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.16);
  padding: 0 vw(18);
  box-sizing: border-box;
  .readUserList {
    display: flex;
    align-items: center;
    font-size: vw(12);
    color: #666666;
    .userPic {
      width: vw(26);
      height: vw(26);
      margin-right: vw(5);
    }
    .more {
      display: flex;
      align-items: center;
      justify-content: space-around;
      width: vw(26);
      height: vw(26);
      opacity: 0.38;
      background: #999999;
      border-radius: 50%;
      color: #fff;
      font-size: vw(16);
      margin-right: vw(5);
    }
  }
  .rightPart {
    display: flex;
    align-items: center;
    flex: 1;
    justify-content: flex-end;
    .item {
      display: flex;
      flex-direction: column;
      align-items: center;
      font-size: vw(11);
      color: #666666;
      margin-left: vw(20);
      .shareText {
        transform: translateX(-0.5px);
      }
      &.memberIsLike {
        color: #ff5f5f;
      }
      .iconfontBox {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-around;
        width: vw(20);
        height: vw(20);
      }
      .animationIconfontBox {
        position: relative;
        .icon-dianzan11 {
          position: absolute;
          &.icon-animation {
            transition-duration: 1s;
            &.heart {
              transform: scale(2);
              opacity: 0;
            }
          }
        }
      }
      .iconfont {
        font-size: vw(20);
      }
      .icon-fenxiang2 {
        font-size: vw(19);
      }
    }
  }
}
</style>
